export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/397c1296d824757d348180c280ed66e3.svg";